// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_2uuoQ-H2QZDlKhFo9tBuNG","arrowUp":"_1QQMCh96zk6zRPRNYiO73V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollButton/ScrollButton.scss
// module id = 1165
// module chunks = 0